import { uniqueId } from 'lodash';
import { BLANK_CONDITIONAL_CONTENT_CLAUSE } from '../../constants';
import { createBlankCondition } from './createBlankCondition';

export const createBlankClause = () => ({
  ...BLANK_CONDITIONAL_CONTENT_CLAUSE,
  conditions: [createBlankCondition()],
  id: uniqueId(),
});
